import { createFileRoute } from '@tanstack/react-router'
import node, {
  type accountAuditLogsPageQuery,
} from '#gen/relay/accountAuditLogsPageQuery.graphql'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

export const Route = createFileRoute(
  '/_dashboard/$account/settings/audit-logs',
)({
  staticData: { title: 'Audit Logs' },
  loader({ context, params }) {
    return context.preload<accountAuditLogsPageQuery>(node, params)
  },
  component: lazyLoadedComponent(
    () => import('#app/pages/settings/account-audit-logs-page'),
    'AccountAuditLogsPage',
  ),
})
